<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
<!--  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">-->
    <f7-toolbar>

      <div class="left">

      </div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>
    <!-- Scrollable sheet content -->
    <!--    <f7-page-content>-->

    <f7-block>
      <f7-block-title>Lineaire progressie</f7-block-title>
      <f7-segmented strong>
        <f7-button @click="update_linear_progression_settings('0.000')"
                   :active="activity.settings.linear_progression === '0.000'"
        >
          0kg
        </f7-button>
        <f7-button @click="update_linear_progression_settings('0.125')"
                   :active="activity.settings.linear_progression === '0.125'"
        >
          0.125kg
        </f7-button>
        <f7-button @click="update_linear_progression_settings('0.250')"
                   :active="activity.settings.linear_progression === '0.250'"
        >
          0.250kg
        </f7-button>
        <f7-button @click="update_linear_progression_settings('0.500')"
                   :active="activity.settings.linear_progression === '0.500'"
        >
          0.500kg
        </f7-button>
      </f7-segmented>
    </f7-block>

    <f7-block-title>Gewicht houder</f7-block-title>
    <f7-list class="list-strong list-outline list-dividers">
      <f7-list-button @click="openEquipmentPicker" :title="equipment[activity.settings.equipment]"></f7-list-button>
    </f7-list>
    <input type="hidden"
           readonly="readonly"
           v-show="false"
           ref="equipment_picker"
    />

  </f7-sheet>
</template>

<script>
import {f7, f7ready, theme} from 'framework7-vue';

export default {
  components: {},

  props: [
    'show',
    'activity',
    'training_session',
  ],

  mixins: [],

  data: function () {
    return {
      equipmentPicker: null,
      equipment: {},
    };
  },

  computed: {
    user_id() {
      return this.$store.state.current_user.data.id;
    },
  },

  created() {
    //
  },

  mounted() {
    this.initializeEquipmentPicker();
  },

  methods: {
    update_equipment_settings(event) {
      console.log('update_equipment_settings event', event);
      this.activity.settings.equipment = event.value[0];
      this.update_activity();
    },
    update_linear_progression_settings(weight) {
      this.activity.settings.linear_progression = weight;
      this.update_activity();
    },
    /**
     * Stores an Activity when the user is done editing
     */
    update_activity() {
      // Moet met update_only anders gaat het kapot
      this.$store.dispatch('activities/update_only', {
        user_id: this.user_id,
        activity_id: this.activity.id,
        training_session_id: this.training_session.id,
        settings: this.activity.settings,
      });
    },
    openEquipmentPicker() {
      this.equipmentPicker.open();
    },
    initializeEquipmentPicker() {
      this.equipment = this.$store.getters['activities/equipment'];
      let equipmentValues = Object.keys(this.equipment);
      let equipmentDisplayValues = [];

      equipmentValues.forEach(equipmentValue => {
        equipmentDisplayValues.push(this.equipment[equipmentValue]);
      });

      const vm = this;

      this.equipmentPicker = f7.picker.create({
        inputEl: vm.$refs['equipment_picker'],
        openIn: 'sheet',
        value: [vm.activity.settings.equipment],
        displayValues: function (values, displayValues) {
            return displayValues[0];
        },
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: equipmentValues,
            displayValues: equipmentDisplayValues,
          },
        ],
        on: {
          open: function (picker) {
            //
          },
          close: function (picker) {
            vm.update_equipment_settings(picker);
          },
        }
      });
    }
  },

  watch: {
    //
  }
};
</script>
